module.exports = __webpack_public_path__ + "static/media/楼长制2.3d7f28f9.png";